import React from 'react';
import { Container, Section } from '../ui/Section';
import { ButtonLink, ButtonExternal } from '../ui/Button';
import { EventCard } from '../events/EventCard';
import { Reveal, stagger } from '../motion/Reveal';
import { DoodleScatter } from '../brand/DoodleScatter';
import { visibleSpecialEvents } from '../../data/events';
import { externalLinks } from '../../data/site';
export function UpcomingEvents() {
  // Only one verified special event is entered right now. A two-column grid
  // would leave half the panel empty, so a single event centers instead.
  const single = visibleSpecialEvents.length === 1;
  return <Section className="relative overflow-hidden bg-brand-blue py-16 sm:py-20" labelledBy="events-heading" data-id="element-191" data-mp="1xwuweofq6zo">
      {/* Light-blue panel: scatter uses navy, cream, and yellow only. */}
      <DoodleScatter tone="blue" seed="upcoming-events" layout={single ? 'narrow' : 'full'} data-id="element-192" data-mp="3o3tnirnxlvsg" />
      <Container className="relative" data-id="element-193" data-mp="3t1va3mkkgd8o">
        <Reveal data-id="element-194" data-mp="3t510d54xll5z">
          <div className={single ? 'mx-auto max-w-2xl text-center' : 'max-w-2xl'} data-id="element-195" data-mp="39dqucsp3x98u">
            <h2 id="events-heading" className="font-display text-3xl font-extrabold leading-tight tracking-tight text-brand-navy sm:text-5xl" data-id="element-196" data-mp="34ewbxrv1xmp9">
              What’s happening at BCM
            </h2>
            <p className="mt-4 font-sans text-[17px] leading-relaxed text-ink" data-id="element-197" data-mp="3dgnewoy7jfff">
              Start with a worship night, join us during Welcome Week, or connect with someone who can
              help you find your place.
            </p>
          </div>
        </Reveal>

        <ul className={`mt-10 grid gap-5 ${single ? 'mx-auto max-w-xl' : 'md:grid-cols-2'}`} data-id="element-198" data-mp="2zfjekd6k0x8f">
          {visibleSpecialEvents.map((event, index) => <Reveal key={event.id} as="li" delay={stagger(index)} className="h-full" data-id="element-199" data-mp="26z8n486ohh08" data-mpi={index}>
              <EventCard event={event} data-id="element-200" data-mp="220f8udjkhlz0" />
            </Reveal>)}
        </ul>

        <Reveal delay={0.1} data-id="element-201" data-mp="21yckrz1z62wx">
          <div className={`mt-9 flex flex-col gap-3 sm:flex-row ${single ? 'sm:justify-center' : ''}`} data-id="element-202" data-mp="5xkd9246o72l">
            <ButtonLink to="/events" data-id="element-203" data-mp="auj4ncwgpzx3">See All Events</ButtonLink>
            <ButtonExternal href={externalLinks.getConnectedForm} variant="secondary" data-id="element-204" data-mp="fo55m7t9kfd2">
              Get Event Updates
            </ButtonExternal>
          </div>
        </Reveal>
      </Container>
    </Section>;
}